import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { postsLatestState$ } from '../../redux/selectors';
import moment from 'moment';

export default function SectionTop() {
  const posts = useSelector(postsLatestState$);
  const [firstItem, ...rest] = posts ?? [];

  if (!firstItem) {
    return null;
  }

  return (
    <div className="row section-top justify-content-center">
      <div className="col-lg-6 col-sm-12 post-item main-item"
        style={{ backgroundImage: `url(${firstItem.image})` }}>
        <div className="text-in-thumb">
          <div>
            <span className="tag-item">
              <Link to={`/search/type?value=${firstItem.type}`}>{firstItem.type}</Link>
            </span>
          </div>
          <h2>
            <Link to={`/${firstItem.category}s/${firstItem._id}`}>{firstItem.title}</Link>
          </h2>
          <div className="post-meta">
            <span className="date-meta">{moment(firstItem.createdAt).locale('vi').format("dddd, MMMM Do YYYY")}</span>
            {/* <span className="comment-count-meta">
              <i className="fa fa-commenting-o" aria-hidden="true"></i>&nbsp;{firstItem.commentCount}
            </span> */}
            <span className="favorite-count-meta">
              <i className="fa fa-heart-o" aria-hidden="true"></i>&nbsp;{firstItem.likeCount}
            </span>
          </div>
        </div>
      </div>
      <div className="col-lg-6 col-sm-12">
        <div className="row">
          {rest.map(item => (
            <div className="col-6 post-item sub-item" key={item._id}
              style={{ backgroundImage: `url(${item.image})` }}>
              <div className="text-in-thumb">
                <div>
                  <span className="tag-item">
                    <Link to={`/search/type?value=${item.type}`}>{item.type}</Link>
                  </span>
                </div>
                <h2>
                  <Link to={`/${firstItem.category}s/${item._id}`}>{item.title}</Link>
                </h2>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}